import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { MyDatePickerModule } from 'mydatepicker';
// import { OfficeNewComponent } from './office-new/office-new.component';
import {BrowserModule} from '@angular/platform-browser';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { HoteliersPermitsSigninComponent } from './hoteliers-permits-signin/hoteliers-permits-signin.component';
import { HoteliersStayManagementComponent } from './hoteliers-stay-management/hoteliers-stay-management.component';
import { HoteliersStructuresManagementComponent } from './hoteliers-structures-management/hoteliers-structures-management.component';
import { HoteliersStructuresListComponent } from './hoteliers-structures-list/hoteliers-structures-list.component';
import { HoteliersStructuresRoomsComponent } from './hoteliers-structures-rooms/hoteliers-structures-rooms.component';
import { HoteliersPermitsCalendarComponent } from './hoteliers-permits-calendar/hoteliers-permits-calendar.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MyDatePickerModule } from 'mydatepicker';
import { FileUploadModule } from 'ng2-file-upload';
import { FileSelectDirective } from 'ng2-file-upload';
import { HoteliersPaymentComponent } from './hoteliers-payment/hoteliers-payment.component';
import { CreditCardDirectivesModule } from 'angular-cc-library';
import { TypeaheadModule } from 'ngx-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { PaginationModule } from 'ngx-bootstrap/pagination';








@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    ReactiveFormsModule,
    NgbModule,
    NgxSpinnerModule,
    MyDatePickerModule,
    FileUploadModule,
    CreditCardDirectivesModule,
 TypeaheadModule.forRoot(),
 BsDatepickerModule.forRoot(),
 TimepickerModule.forRoot(),
 PaginationModule.forRoot()





  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [HoteliersPermitsSigninComponent,
    HoteliersStayManagementComponent,
    HoteliersStructuresManagementComponent,
    HoteliersStructuresListComponent,
    HoteliersStructuresRoomsComponent,
    HoteliersPermitsCalendarComponent,
    HoteliersPaymentComponent,
    ]
})
export class HotelierPermitsModule {}






// WEBPACK FOOTER //
// ./src/app/views/hoteliers-permits/hotelierpermits.module.ts